import {CSSProperties} from '../../../styleSheet';
import {BaseOverflowProps} from '../types';

export const buildOverflowStyle = ({
  scrollable,
  overflow,
}: BaseOverflowProps = {}): CSSProperties => {
  return {
    ...(scrollable ? {overflow: 'auto'} : {}),
    ...(overflow ? {overflow} : {}),
  };
};
